import React from "react";
import { Link, withRouter } from "react-router-dom";
import { useLastLocation } from "react-router-last-location";
import { connect } from "react-redux";
import objectPath from "object-path";
import * as builder from "../../ducks/builder";
import KTToggle from "../../_assets/js/toggle";
import { toAbsoluteUrl } from "../../../_metronic/utils/utils";
import UserProfile from "../../../app/partials/layout/UserProfile";
import * as aiChatDuck from "../../../app/store/ducks/ai-chat.duck";
import * as dashboardDuck from "../../../app/store/ducks/dashboard.duck";
import BetterButton from '../../../app/components/BetterButton';

class HeaderMobile extends React.Component {
	toggleButtonRef = React.createRef();

	componentDidMount() {
		new KTToggle(this.toggleButtonRef.current, this.props.toggleOptions);
	}

	render() {
		const {
			//   headerLogo,
			asideDisplay,
			//   headerMenuSelfDisplay,
			headerMobileCssClasses,
			headerMobileAttributes,
			user,
			aiChat,
			dashboard,
			location,
			history,
			lastLocation,
		} = this.props;

		const chatToggle = (e) => {
			e.preventDefault();

			this.props.toggleChat();
		};

		const handleBackClick = () => {
			if (dashboard.onBackClick) {
				dashboard.onBackClick();
			} else {
				const hasValidLastLocation = lastLocation && 
					lastLocation.pathname !== location.pathname && 
					lastLocation.pathname !== '/dashboard' && 
					lastLocation.pathname !== '/';
				
				if (hasValidLastLocation) {
					history.push(lastLocation.pathname);
				} else {
					// Caso contrário, usa o histórico do navegador
					// Se não houver histórico, o goBack() não fará nada
					history.goBack();
				}
			}
		};

		const isDashboardInitial = location.pathname === '/dashboard' || location.pathname === '/';
		const showBackButton = dashboard.expandedWidget || !isDashboardInitial;

		return (
			<div
				id="kt_header_mobile"
				className={`kt-header-mobile ${headerMobileCssClasses}`}
				{...headerMobileAttributes}
			>
				<div className="kt-header-mobile__logo">
					<Link to="/">
						<img alt="logo" src={toAbsoluteUrl("/images/logo-white.png")} style={{ width: '120px' }} />
					</Link>
				</div>

				<div className="kt-header-mobile__toolbar">
					{showBackButton && (
						<div style={{ paddingRight: '10px' }}>
							<BetterButton 
								text="Voltar" 
								outline 
								colorType="primary" 
								icon="fa fa-arrow-left" 
								style={{ width: 80, height: 36, fontSize: '12px' }} 
								onClick={handleBackClick}
							/>
						</div>
					)}

					{[1, 3].includes(user?.usu_id_empresa) ?
						<button className={`btn-ai-header mobile ${aiChat.toggleChat ? 'active' : ''}`} onClick={(e) => chatToggle(e)}>
							<img src={toAbsoluteUrl("/images/ai/sparkles.svg")} alt="AI Chat" style={{ maxWidth: '100%', height: 'auto' }} />
						</button>
						: null
					}

					{asideDisplay && (
						<button
							className="kt-header-mobile__toggler kt-header-mobile__toggler--left"
							id="kt_aside_mobile_toggler"
						>
							<span />
						</button>
					)}

					{/*
          // DESCOMENTAR CASO QUEIRA QUE O HEADER ALTERNATIVO VOLTE A FUNCIONAR
          {headerMenuSelfDisplay && (
            <button
              className="kt-header-mobile__toggler"
              id="kt_header_mobile_toggler"
            >
              <span />
            </button>
          )}
 */}

					{/*
          // DESCOMENTAR CASO QUEIRA QUE O MOBILE TOPBAR DE VOLTA
          <button
            ref={this.toggleButtonRef}
            className="kt-header-mobile__topbar-toggler"
            id="kt_header_mobile_topbar_toggler"
          >
            <i className="flaticon-more" />
          </button>
        */}

					<div className="user-profile-mobile" style={{ paddingLeft: '15px' }}>
						<UserProfile showAvatar={true} showHi={false} showBadge={false} />
					</div>

				</div>
			</div>
		);
	}
}

const mapStateToProps = store => ({
	headerLogo: builder.selectors.getStickyLogo(store),
	asideDisplay: objectPath.get(
		store.builder.layoutConfig,
		"aside.self.display"
	),
	headerMenuSelfDisplay:
		objectPath.get(store.builder.layoutConfig, "header.menu.self.display") ===
		true,
	toggleOptions: {
		target: "body",
		targetState: "kt-header__topbar--mobile-on",
		togglerState: "kt-header-mobile__toolbar-topbar-toggler--active"
	},
	headerMobileCssClasses: builder.selectors.getClasses(store, {
		path: "header_mobile",
		toString: true
	}),
	headerMobileAttributes: builder.selectors.getAttributes(store, {
		path: "aside_menu"
	}),
	user: store.auth.user,
	aiChat: store.aiChat,
	dashboard: store.dashboard
});

// Wrapper para usar o hook useLastLocation
const HeaderMobileWithLastLocation = (props) => {
	const lastLocation = useLastLocation();
	return <HeaderMobile {...props} lastLocation={lastLocation} />;
};

export default withRouter(connect(mapStateToProps, { ...aiChatDuck.actions, ...dashboardDuck.actions })(HeaderMobileWithLastLocation));
